export default "__VITE_ASSET__no_ynyGk__"